import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Users, Clock, Globe2 } from 'lucide-react';
import Ololade from '../../components/assets/Ololade.png';
import Ololadebiz from '../../components/assets/Ololadebiz.png';
import snail from '../../components/assets/snail.jpg';

const floatingFoods = [
  {
    src: snail,
    size: 'w-40 h-40',
    animation: {
      x: [0, 120, -80, 60, -40, 0],
      y: [0, -80, 60, -120, 40, 0],
      rotate: [0, 15, -10, 20, -15, 0]
    }
  },
  {
    src: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/104152781_152275989705847_134748792298047762_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=833d8c&_nc_ohc=Y7Wk_y3jh0EQ7kNvwFN65sF&_nc_oc=AdlH6eJKAiD1kN5MTMBbFrzgTI_Tqr-JEPAZXdupm4Pg9DGsbWpJOLoD9yBrcsdEuFA&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=z4rALYIxcNBYyEkAi8Hp9g&oh=00_AfFPMGge_DboFZt9w0PrJmPih4DUYkNEnF1tqSDmXEd5lg&oe=682E08DF',
    size: 'w-32 h-32',
    animation: {
      x: [0, -100, 80, -60, 40, 0],
      y: [0, 60, -80, 120, -60, 0],
      rotate: [0, -20, 15, -25, 10, 0]
    }
  },
  {
    src: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/102378094_147777020155744_8544016924839772160_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=833d8c&_nc_ohc=OfbWm1MXQlEQ7kNvwFff3RM&_nc_oc=AdnM7HdmFxLWcuxUx8Fxy3kG0ZvT3LLHC2slBRCGEjAqjfr0lI1Vd_ndKhjnSGFElXw&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=Tn7WdOjmRklYQFI4Eyrgaw&oh=00_AfHXOLX1HP3JxUpJ2jhZcNeFZOK3KffLNdZH1oVOlwcFCA&oe=682DF11E',
    size: 'w-36 h-36',
    animation: {
      x: [0, 60, -120, 80, -60, 0],
      y: [0, -120, 80, -60, 100, 0],
      rotate: [0, 25, -15, 30, -20, 0]
    }
  }
];

const FEMHero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const backgroundImages = [
    {
      url: Ololade,
      caption: 'Foodstuff Exporter'
    },
    {
      url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/104103512_152275919705854_5066043083235907758_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=833d8c&_nc_ohc=Pq6IbjR0ADkQ7kNvwEAxDMH&_nc_oc=AdnpFn3V1penXItL4mIuVzk633eTZ5C4gWiAt62s16IOnbJ1-IfcRfM5t-zdYxl2a-Q&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=Hu5vV62qssa3ea9_yOB5Aw&oh=00_AfG7s5ny-TgsrghxWjgbkte_XvTsqhXP6j73GKVIhen-jg&oe=682DF4BD',
      caption: 'Traditional Nigerian Smoked Fish'
    },
    {
      url: 'https://scontent-los2-1.xx.fbcdn.net/v/t39.30808-6/482021853_9118276191554816_6457331358731829553_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c6b0&_nc_ohc=-n_8Jh6xwZcQ7kNvwEHTswj&_nc_oc=Adm7sRTItLecaWAP6yhw5nKYS-JMNfkATcnw90GH--ncjMctKeN4VDx_arNv1WPmWxw&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=0hiYlkMf34ZvaFpk_PSj0A&oh=00_AfGvzSJeJaDtLoD8uZhhau0vc_yXg20yUmk0ZcATtY9A8g&oe=680C5C7E',
      caption: 'Masterclass Session'
    },
    {
      url: Ololadebiz,
      caption: 'Foodstuff Exporter'
    },
    {
      url: 'https://scontent-los2-1.xx.fbcdn.net/v/t1.6435-9/119651845_180797923520320_5779582185370445560_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=833d8c&_nc_ohc=aa-xajB57g4Q7kNvwFc8fSO&_nc_oc=AdliGge-3ky3Vmj1Jh8A_qdUlniGVHsiNr5OBIpNFaEqp0UXihfMkUub7gqQhpmwhrc&_nc_zt=23&_nc_ht=scontent-los2-1.xx&_nc_gid=fppAPKP4355YNZrJxxGCeg&oh=00_AfENNrzRUm4HChTwrT4-iqfpE666s9mYPD2Zf9FYXEW5TA&oe=682DF6F8',
      caption: 'Nigerian Yam'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => 
        prev === backgroundImages.length - 1 ? 0 : prev + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  const handleEnrollClick = () => {
    window.open('https://paystack.com/pay/femjune2025', '_blank');
  };

  const handleBrochureDownload = () => {
    // Replace with your actual brochure URL
    window.open('https://drive.google.com/file/d/1EMdQlGpy508s_rq_Ja_Yr01h7v3m7Yvp/view?usp=sharing', '_blank');
  };

  return (
    <div className="relative min-h-screen bg-black">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={backgroundImages[currentImageIndex].url}
          alt={backgroundImages[currentImageIndex].caption}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/60" />
      </div>

      {/* Content Container */}
      <div className="relative min-h-screen flex flex-col justify-center px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-3xl">
            {/* Premium Badge */}
            <div className="mb-8">
              <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-green-100 text-green-800">
                Scale-Up Program
              </span>
            </div>
            
            <h1 className="text-4xl font-bold text-white sm:text-5xl md:text-6xl mb-6">
              Foodstuff Export Masterclass
            </h1>
            
            <p className="text-xl text-gray-200 mb-8">
               Master the art of exporting Nigerian and African foodstuffs to the global market. From local delicacies to staple crops, learn how to tap into the multi-billion dollar international food trade.
            </p>

           <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mb-8">
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4"
                aria-label="Next cohort information"
              >
                <Calendar className="h-5 w-5 sm:h-6 sm:w-6 text-green-400 mb-1 sm:mb-2" />
                <div className="text-xs sm:text-sm text-white">Registration</div>
                <div className="text-sm sm:text-base text-green-400 font-semibold">Always Open</div>
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.05 }}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4"
                aria-label="Course duration"
              >
                <Clock className="h-5 w-5 sm:h-6 sm:w-6 text-green-400 mb-1 sm:mb-2" />
                <div className="text-xs sm:text-sm text-white">Time</div>
                <div className="text-sm sm:text-base text-green-400 font-semibold">Convenient</div>
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.05 }}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4"
                aria-label="Class size information"
              >
                <Users className="h-5 w-5 sm:h-6 sm:w-6 text-green-400 mb-1 sm:mb-2" />
                <div className="text-xs sm:text-sm text-white">Class</div>
                <div className="text-sm sm:text-base text-green-400 font-semibold">LIVE</div>
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.05 }}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4"
                aria-label="Market access information"
              >
                <Globe2 className="h-5 w-5 sm:h-6 sm:w-6 text-green-400 mb-1 sm:mb-2" />
                <div className="text-xs sm:text-sm text-white">Market Access</div>
                <div className="text-sm sm:text-base text-green-400 font-semibold">Global</div>
              </motion.div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleEnrollClick}
                className="w-full sm:w-auto px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-all"
              >
                Enroll Now - ₦60,000
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleBrochureDownload}
                className="w-full sm:w-auto px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all"
              >
                Download Brochure
              </motion.button>
            </div>
          </div>
        </div>

        {/* Image Navigation Dots */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 flex space-x-3">
          {backgroundImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`
                w-2 h-2 rounded-full transition-all duration-300
                ${index === currentImageIndex 
                  ? 'bg-white/90 scale-[1.4]' 
                  : 'bg-white/20 hover:bg-white/40 scale-100'
                }
                focus:outline-none focus:ring-2 focus:ring-white/30
              `}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Floating Food Images */}
      {floatingFoods.map((food, index) => (
        <motion.div
          key={index}
          animate={food.animation}
          transition={{
            duration: 15 + index * 3,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut"
          }}
          className={`absolute opacity-20 z-0 ${food.size}`}
          style={{
            top: `${20 + index * 15}%`,
            left: `${20 + index * 20}%`
          }}
        >
          <img
            src={food.src}
            alt={`Floating Food ${index + 1}`}
            className="w-full h-full object-cover rounded-full"
          />
        </motion.div>
      ))}
    </div>
  );
};

export default FEMHero;